import List from '@mui/material/List';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import FuseNavVerticalTab from './types/FuseNavVerticalTab';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	navigation: {
		'& .fuse-list-item': {
			'&:hover': {
				backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,.04)'
			},
			'&:focus:not(.active)': {
				backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0,0,0,.05)'
			}
		},
		'&.active-square-list': {
			'& .fuse-list-item, & .active.fuse-list-item': {
				width: '100%',
				borderRadius: '0'
			}
		},
		'&.dense': {}
	}
}));

function FuseNavVerticalLayout2(props) {
	const classes = useStyles(props);
	const { navigation, active, dense, className, onItemClick, firstLevel, selectedId } = props;

	function handleItemClick(item) {
		onItemClick?.(item);
	}

	return (
		<List
			className={clsx(
				'navigation whitespace-nowrap items-center flex flex-col',
				classes.navigation,
				`active-${active}-list`,
				dense && 'dense',
				className
			)}
		>
			{navigation.map(_item => (
				<FuseNavVerticalTab
					key={_item.id}
					type={`vertical-${_item.type}`}
					item={_item}
					nestedLevel={0}
					onItemClick={handleItemClick}
					firstLevel={firstLevel}
					dense={dense}
					selectedId={selectedId}
				/>
			))}
		</List>
	);
}

FuseNavVerticalLayout2.propTypes = {
  navigation: PropTypes.array,
  active: PropTypes.bool,
  dense: PropTypes.bool,
  className: PropTypes.string,
  onItemClick: PropTypes.func,
  firstLevel: PropTypes.any,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FuseNavVerticalLayout2;
